import { combineReducers } from 'redux';
// Import reducers
import table from './passes_availability_table_reducer';
import form from './passes_availability_form_reducer';

export default combineReducers({
	table,
	form
});
